const filterJobs = (gsap, ScrollTrigger) => {

  var noFilterResults = $('.no-results'),
      $jobsFilter = $('.jobs-filter');
  
  // Reset filters on page load
  $('.filter-dept').val('all');
  $('.filter-location').val('all');

  $('.select-css').each(function() {
    $(this).after("<span class='holder'></span>");
  });

  $('.select-css').on('change', function() {
    var selectedOption = $(this).find(":selected").text();
    $(this).next(".holder").text(selectedOption);
  }).trigger('change');

  $jobsFilter.on('change', function() {
    var fadeOutItems = $('.department-block, .job-block'),
        swapDuration = 0.6,
        swapDelay = 0.2;

    gsap.to(fadeOutItems, {y: 20, autoAlpha: 0, duration: 0.3, onComplete: showFiltered});

    function showFiltered() {

      // Get selected filter options on form change
      var selectedDepartment = $('.filter-dept').val(),
          selectedLocation = $('.filter-location').val();

      $('.no-results').fadeOut('fast');

      fadeOutItems.hide().promise().done(function() {

        if (selectedDepartment == 'all') {

          var uri = window.location.toString();

          if (uri.indexOf("?") > 0) {
              var clean_uri = uri.substring(0, uri.indexOf("?"));
              window.history.replaceState({}, document.title, clean_uri);
          }

        } else {

          var breakDepartmentTitle = selectedDepartment.replace(/(\s+)(?![A-Za-z0-8])/g, '').toLowerCase(),
              cleanDepartmentTitle = breakDepartmentTitle.replace(/\s+/g, '-'),
              pageUrl = '?dept=' + cleanDepartmentTitle,
              queryParams = new URLSearchParams(window.location.search);

          queryParams.set('dept', cleanDepartmentTitle);
          history.replaceState(null, null, "?"+queryParams.toString());

        }

        if ( selectedLocation == 'all' && selectedDepartment == 'all' ) {

          var showFilteredDepartments = $('.department-block'),
              showFilteredLocation = $('.job-block');

          filteredResults(showFilteredDepartments, showFilteredLocation);

        } else if ( selectedLocation != 'all' && selectedDepartment == 'all' ) {

          var showFilteredDepartments = $('.department-block').has('[data-location="' + selectedLocation + '"]'),
              showFilteredLocation = $('.job-block[data-location="' + selectedLocation + '"]');

          filteredResults(showFilteredDepartments, showFilteredLocation);

        } else if ( selectedLocation == 'all' && selectedDepartment != 'all' ) {

          var showFilteredDepartments = $('[data-department="' + selectedDepartment + '"]'),
              showFilteredLocation = $('.job-block');

          filteredResults(showFilteredDepartments, showFilteredLocation);

        } else {

          var showFilteredDepartments = $('.job-block[data-location="' + selectedLocation + '"]').closest('[data-department="' + selectedDepartment + '"]'),
              showFilteredLocation = $('.job-block[data-location="' + selectedLocation + '"]');

          filteredResults(showFilteredDepartments, showFilteredLocation);

        }

      });

      function filteredResults(department, location) {

        department.add(location).show().promise().done(function() {
          if (department.length >= 1) {
            gsap.to(department, {y: 0, autoAlpha: 1, duration: swapDuration, delay: swapDelay, onComplete: () => {
              ScrollTrigger.refresh();
            }});
          }
          if (location.length >= 1) {
            gsap.to(location, {y: 0, autoAlpha: 1, duration: swapDuration, delay: swapDelay, onStart: noResults, onComplete: () => {
              ScrollTrigger.refresh();
            }});
          }
        });

      }

    }

    function noResults() {

      if ( !$('.department-block').is(":visible") ) {
        noFilterResults.fadeIn('fast');
      }

    }

  });
  
}

export {
  filterJobs
};